module.exports = __webpack_public_path__ + "img/ge.a397fa63.svg";